import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { Carousel, CarouselContent, CarouselItem, } from '@/components/ui/carousel';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { UploadCard } from './UploadCard';
export const FilesCarousel = ({ filesToUpload, handleRemoveFile }) => {
    return (_jsx(_Fragment, { children: _jsx(Carousel, { opts: {
                align: 'center',
                containScroll: 'trimSnaps',
                slidesToScroll: 1,
                dragFree: true,
                loop: true,
            }, className: cn('w-[calc(100%-40px)]'), children: _jsxs(ScrollArea, { className: "w-full pb-2", style: { height: 'fit-content' }, children: [_jsx(CarouselContent, { className: cn('-ml-1'), children: filesToUpload.map(({ file_id, original_name, content_type }, index) => {
                            return (_jsx(CarouselItem, { className: cn('basis-[130px] pl-2'), children: _jsx(UploadCard, { fileName: original_name, content_type: content_type, handleClose: () => handleRemoveFile(file_id), id: file_id }, file_id) }, index));
                        }) }), _jsx(ScrollBar, { orientation: "horizontal", className: "mt-1" })] }) }) }));
};
